import { RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';

import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { SiteMetadataSelectors } from '~src/bootstrap/redux/selectors/SiteMetadataSelectors';

import { Messages } from '../../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../../commonInfra/components/FormikRadioButtonGroup';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const ADMIN_INSIGHTS_PUBLISH_FREQUENCY_SECTION_TEST_ID = 'admin-insights-publish-frequency-setting';
export const ADMIN_INSIGHTS_PUBLISH_FREQUENCY_FORMIK_RADIO_BUTTONS_TEST_ID = 'admin-insights-publish-frequency-formik-radio-buttons';
export const ADMIN_INSIGHTS_PUBLISH_FREQUENCY_DAILY_RADIO_BUTTON_TEST_ID ='admin-insights-publish-frequency-daily-radio-button';
export const ADMIN_INSIGHTS_PUBLISH_FREQUENCY_WEEKLY_RADIO_BUTTON_TEST_ID = 'admin-insights-publish-frequency-weekly-radio-button';

export type AdminInsightsPublishFrequencyProps = SiteSettingsForSiteAdminProps<'adminInsightsPublishFrequency'>;

export function AdminInsightsPublishFrequencySection(props: AdminInsightsPublishFrequencyProps) {
    return AdminInsightsPublishFrequencyInternal(props);
}

export function AdminInsightsPublishFrequencyInternal(props: AdminInsightsPublishFrequencyProps) {
    const isAdminDataSourceEnabled = useSelector(SiteMetadataSelectors.isAdminInsightsEnabled);
    const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
    const buttonList = React.useMemo(() => getButtons(), []);

    return (isOnlineEnvironment && isAdminInsightsEnabledWithValidFrequency(isAdminDataSourceEnabled,
        props.settings.adminInsightsPublishFrequency)) ? (
        <SettingsSection
        title={Messages.adminInsightsPublishFrequencyHeader()}
        description={Messages.adminInsightsPublishFrequencyDescription()}
        testId={ADMIN_INSIGHTS_PUBLISH_FREQUENCY_SECTION_TEST_ID}
        >
            <FormikRadioButtonGroup
            aria-label={Messages.adminInsightsPublishFrequencyHeader()}
            buttonList={buttonList}
            className={settingsRadioButtonItemHeight}
            testId={ADMIN_INSIGHTS_PUBLISH_FREQUENCY_FORMIK_RADIO_BUTTONS_TEST_ID}
            name={'settings.adminInsightsPublishFrequency'}
            />
        </SettingsSection>
    ) : null;
}

function isAdminInsightsEnabledWithValidFrequency(isAdminDataSourceEnabled: boolean, publishFrequency: number): boolean {
    return isAdminDataSourceEnabled && (publishFrequency === 0 || publishFrequency === 1);
}

function getButtons(): RadioButtonWithLabelOption<number>[] {
    return [
        {
            label: Messages.daily(),
            testId: ADMIN_INSIGHTS_PUBLISH_FREQUENCY_DAILY_RADIO_BUTTON_TEST_ID,
            value: 0
        },
        {
            label: Messages.weekly(),
            testId: ADMIN_INSIGHTS_PUBLISH_FREQUENCY_WEEKLY_RADIO_BUTTON_TEST_ID,
            value: 1
        }
    ];
}

/* Register component in settings registry */
export const AdminInsightsPublishFrequencySpecs = componentRegistryEntry({
  name: 'AdminInsightsPublishFrequencySection',
  component: AdminInsightsPublishFrequencySection
});
